import { create } from 'zustand';
import { defaultWhite } from '../components/widgets/RichText/Config';

interface PageStore {
  lastSectionBackgroundColor: string;
  setLastSectionBackgroundColor: (lastSectionBackgroundColor: string) => void;
}

export const usePageStore = create<PageStore>(set => ({
  lastSectionBackgroundColor: defaultWhite.hexCode,
  setLastSectionBackgroundColor: lastSectionBackgroundColor =>
    set(() => ({ lastSectionBackgroundColor })),
}));
